import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ComplexModalTemplate } from '@connect-services/client/components/complexe-modal/complex-modal-template.component';
import { ModalResultEnum } from '@connect-services/client/models/common.model';
import { RessourcesModule } from '@ressources/client/ressources.module';

export interface FieldInterventionControlResultCommentModalData {
    comment?: string;
    maxLength: number;
}

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ComplexModalTemplate, RessourcesModule],
    selector: 'app-field-intervention-control-result-comment-modal',
    styleUrl: './field-intervention-control-result-comment-modal.component.scss',
    templateUrl: './field-intervention-control-result-comment-modal.component.html',
})
export class FieldInterventionControlResultCommentModalComponent {
    protected readonly data = inject<FieldInterventionControlResultCommentModalData>(MAT_DIALOG_DATA);

    // eslint-disable-next-line @typescript-eslint/member-ordering
    protected readonly canConfirm = computed<boolean>(() => {
        const initialComment = (this.data.comment ?? '').trim();
        const comment = this.comment().trim();

        return comment !== initialComment && (comment.length > 0 || initialComment.length > 0);
    });
    protected readonly commentControl = new FormControl(this.data.comment ?? '', {
        nonNullable: true,
    });

    private readonly comment = toSignal(this.commentControl.valueChanges, {
        initialValue: this.commentControl.value,
    });
    private readonly dialogRef = inject(
        MatDialogRef<FieldInterventionControlResultCommentModalComponent, string | null>,
    );

    public onClickEvent(result: ModalResultEnum): void {
        if (result === ModalResultEnum.CANCEL) {
            this.dialogRef.close(null);

            return;
        }

        this.dialogRef.close(this.commentControl.value.trim());
    }
}
